"use strict";

(function () {
  'use strict';

  function SocketBridge(MessageController) {
    var SocketPubSubBridge = function SocketPubSubBridge() {
      this.socket = io('//' + window.location.host);
      this.reconnect = false;
      this.subscriptions = [];
      this.socket.on('client-connect', function (data) {
        console.log('client ' + data.clientId + ' has connected to server ' + data.server); // if reconnect is needed

        if (this.reconnect) {
          // if subscriptions have been registered loop thru them and subscribe
          if (this.subscriptions.length) {
            this.subscriptions.forEach(function (subscription) {
              this.subscribe(subscription.event, subscription.application);
            }.bind(this));
          }

          this.reconnect = false;
        }
      }.bind(this));
      this.socket.on('subscribed', function (data) {
        // register w/ local messagecontroller to pass all message thru to the message controller
        this.socket.on(data.event, function (message) {
          console.log(message);
          MessageController.publish(data.event, message);
        });
        var sub = {
          event: data.event,
          application: data.application
        }; // check if in array here first

        if (!_containsObject(sub, this.subscriptions)) {
          this.subscriptions.push(sub);
        }

        console.log('client ' + data.clientId + ' has subscribed to events in room ' + data.room + ' on server ' + data.server);
      }.bind(this));
      this.socket.on('server-offline', function (serverId) {
        this.reconnect = true;
        console.log('server ' + serverId + ' has gone offline');
      }.bind(this));
    };

    SocketPubSubBridge.prototype.subscribe = function (event, application) {
      if (window.sessionStorage.token) {
        this.socket.emit('subscribe', {
          event: event,
          token: window.sessionStorage.token,
          application: application
        });
      }
    };

    SocketPubSubBridge.prototype.unsubscribe = function (event, application) {
      this.socket.emit('unsubscribe', {
        event: event,
        application: application
      });
    };

    this.controller = new SocketPubSubBridge(); // ------------- private methods -------------

    function _containsObject(obj, list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].application == obj.application && list[i].event == obj.event) {
          return true;
        }
      }
    }
  }

  SocketBridge.$inject = ['MessageController'];
  angular.module('lr.services.socket-bridge', []).service('SocketBridge', SocketBridge);
})();